'use strict';

const ImageHotspot = (($) => {

    const NAME = 'imageHotspot';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class ImageHotspot {

        // totalWidth = 0;

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;
            // console.log(this.$element);

            this.elements = $('.js-hotspot-trigger');

            this.inAction = false;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            // console.log('image hotspot');

            $('body').append('<div class="js-hotspot-temp"></div>');

            this.elements.each(function() {
                var offset = $(this).offset();
                var left = offset.left;
                // console.log(left);
                // console.log($(window).width());

                var leftOfCenter = left < $(window).width()/2;
                // console.log(leftOfCenter);

                if (!leftOfCenter) {
                    $(this).parent().addClass('roc');
                } else {
                    $(this).parent().addClass('loc');
                }
            });

            // var offset = this.$element.offset();
            // var left = offset.left;
            // console.log(left);
            // console.log($(window).width());
            //
            // this.leftOfCenter = left < $(window).width()/2;
            // console.log(this.leftOfCenter);
            //
            // if (!this.leftOfCenter) {
            //     this.$element.parent().addClass('roc');
            // } else {
            //     this.$element.parent().addClass('loc');
            // }
        }

        addEventListeners() {
            var _self = this;

            this.elements.on('dblclick', function(e) {
               e.preventDefault();
            });

            this.elements.on('click', function (e) {
                // console.log('click');
                if (!_self.inAction) {
                    // console.log('do something');
                    _self.inAction = true;
                    _self.handleToggle(e)
                }
            });

            // this.$element.on('click', function (e) {
            //     _self.handleToggle(e)
            // });

            $('.js-hotspot-temp').on('click', '.js-hotspot-close', function(e) {
                // console.log('close');
                _self.closeHotspot(e)
            });
        }

        closeHotspot(e) {
            if (this.inAction) {
                return;
            }
            // console.log('close' + $(e.currentTarget).attr('id'));
            var _self = this;

            $('.js-hotspot-content').fadeOut(function() {
                // _self.inAction = false;
                $('.js-hotspot-temp').find('> .js-hotspot-trigger').remove();
                // $('body').find('> .js-hotspot-content').remove();

                $('.image-hotspot__container .js-hotspot-trigger').removeClass('open');
                $('.image-hotspot__container').removeClass('open');

                setTimeout(function() {
                    // $('body').find('> .js-hotspot-trigger').remove();
                    $('.js-hotspot-temp').find('> .js-hotspot-content').remove();
                    _self.inAction = false;
                }, 1000);
            });
        }

        handleToggle(e) {
            // console.log(this.inAction);
            // if (this.inAction) {
            //     return;
            // }
            // // console.log('click');
            //
            var _self = this;
            //
            // this.inAction = true;

            var trigger = e.currentTarget;
            var targetId = $(trigger).attr('data-hs');

            if ($(trigger).hasClass('open')) {
                // console.log('close hotspot');
                $(trigger).parents('.mod_article').css('z-index', '').css('position', '');

                $(trigger).removeClass('open');
                $(trigger).parent().removeClass('open');

                $('#' + targetId).fadeOut(function() {
                    // _self.inAction = false;

                });

                // $('#' + targetId + '_clone').fadeOut(function() {
                //     _self.inAction = false;
                //     $(this).remove();
                //     $('body').find('.js-hotspot-trigger').remove();
                //     $('body').find('.js-hotspot-content').remove();
                // });

            } else {

                $(trigger).parents('.mod_article').css('z-index', '2').css('position', 'relative');

                // console.log('hotspot show');

                $('.js-hotspot-temp').html('');

                $('.js-hotspot-content').hide();
                $('.js-hotspot-trigger').removeClass('open');
                $('.js-hotspot-trigger').parent().removeClass('open');

                $(trigger).addClass('open');
                $(trigger).parent().addClass('open');

                $(trigger).clone().addClass('js-hotspot-close').appendTo('.js-hotspot-temp');

                var clone = $('#' + targetId).clone();
                clone.attr('id', '#' + targetId + '_clone').appendTo('.js-hotspot-temp');

                $('#' + targetId).fadeIn(function() {
                    // console.log(_self.inAction);
                    // _self.inAction = false;
                });

                // console.log('#' + targetId + '_clone');
                clone.fadeIn(function() {
                    // console.log(_self.inAction);
                    // _self.inAction = false;
                });
            }

            setTimeout(function() {
                // console.log('reset');
                _self.inAction = false;
            }, 1000)

        }


        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    ImageHotspot.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new ImageHotspot(this, _config)
            })
        }
    }

    $.fn[NAME] = ImageHotspot._jQueryInterface;
    $.fn[NAME].Constructor = ImageHotspot;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return ImageHotspot._jQueryInterface
    };

    return ImageHotspot;

})(jQuery);

export default ImageHotspot;